import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { DividendStats } from './dividend.types';

export const useDividendStats = ({ companyId }: { companyId: string }) => {
  const { data, isLoading } = useAppQuery({
    queryKey: [QueryKey.DIVIDEND_STATS, companyId],
    queryFn: () => ApiService.get<DividendStats>({ endpoint: BackendRoute.DIVIDENDS_STATS }),
  });

  return { isLoading, stats: data };
};
